export const FAMILY_PROFILE_UUID_STORAGE_KEY = 'family_profile_uuid'
export const SAVED_POSITION_STORAGE_KEY = 'saved_position'
